import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AppsIcon from "@mui/icons-material/Apps";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";

const appUIConfigs = {
  
  incident: {
    name: 'incident',
    label: 'Support Centre',
    description: 'Client support & tickets',
    icon: SupportAgentIcon,
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%)',
    shadowColor: 'rgba(59, 130, 246, 0.3)',
  },
  lead: {
    name: 'lead',
    label: 'Lead',
    description: 'Manage your leads',
    icon: LeaderboardIcon,
    gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%)',
    shadowColor: 'rgba(16, 185, 129, 0.3)',
  },
  billing: {
    name: 'billing',
    label: 'Billing',
    description: 'Invoices & payments',
    icon: ReceiptLongIcon,
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(217, 119, 6, 0.05) 100%)',
    shadowColor: 'rgba(245, 158, 11, 0.3)',
  },
  contacts: {
    name: 'contacts',
    label: 'Contacts',
    description: 'Manage your contacts',
    icon: AppsIcon, // You can replace with a more suitable icon if available
    gradient: 'linear-gradient(135deg, #06beb6 0%, #48b1f3 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(6, 190, 182, 0.1) 0%, rgba(72, 177, 243, 0.05) 100%)',
    shadowColor: 'rgba(72, 177, 243, 0.3)',
  },
  recruit: {
    name: 'recruit',
    label: 'Recruit',
    description: 'Hiring & recruitment',
    icon: PersonSearchIcon,
    gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    hoverGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(124, 58, 237, 0.05) 100%)',
    shadowColor: 'rgba(139, 92, 246, 0.3)',
  },
};

export default appUIConfigs;
